'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bootStripe = exports.getStripe = undefined;

var _lodash = require('lodash');

var _getClientConfig = require('../../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stripeBooting = false;

var createStripe = function createStripe() {
    if (window.Stripe && (0, _lodash.isFunction)(window.Stripe)) return Promise.resolve(window.Stripe);

    return new Promise(function (resolve, reject) {
        if (stripeBooting) return resolve();

        var stripe = document.createElement('script');
        stripe.type = 'text/javascript';
        stripe.async = true;
        stripe.src = 'https://js.stripe.com/v2/';

        stripeBooting = true;

        var scripts = document.getElementsByTagName('script')[0];
        scripts.parentNode.insertBefore(stripe, scripts);

        stripe.addEventListener('load', function () {
            stripeBooting = false;
            resolve(window.Stripe);
        });
    });
};

var getStripe = exports.getStripe = function getStripe() {
    if (window.Stripe && (0, _lodash.isFunction)(window.Stripe)) return window.Stripe;
};

var bootStripe = exports.bootStripe = function bootStripe() {
    return createStripe().then(function (stripe) {
        stripe.setPublishableKey((0, _getClientConfig2.default)().payment.publicKey);
    });
};

exports.default = getStripe;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/creditCard/stripeService.js
// module id = 432
// module chunks = 0